import { render, staticRenderFns } from "./searchTop.vue?vue&type=template&id=230d36bb&scoped=true&"
import script from "./searchTop.vue?vue&type=script&lang=js&"
export * from "./searchTop.vue?vue&type=script&lang=js&"
import style0 from "./searchTop.vue?vue&type=style&index=0&id=230d36bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230d36bb",
  null
  
)

export default component.exports